<script setup lang="ts">
const { cms } = useRuntimeConfig().public
</script>

<template>
  <UButtonNew
    :to="{
      name: 'om-path',
      params: { path: 'kundeservice' },
      query: { side: cms.customerServicePageLocationId },
    }"
  >
    <template #prepend>
      <slot name="prepend" />
    </template>
    <slot>
      Kundeservice
    </slot>
    <template #append>
      <slot name="append" />
    </template>
  </UButtonNew>
</template>
